// Auto-generate SEO ALT text per image, per language, from product info.
import { productName } from "./product";

const CONJ = { en: "in", nl: "in", fr: "en", de: "in" };
const PHOTO = { en: "photo", nl: "foto", fr: "photo", de: "Foto" };

export const ALT_LANGS = ["en", "nl", "fr", "de"];

export function autoAlt(product, index = 0, lang = "en", categoryLabel = "") {
  if (!product || !product.name) return "";
  let s = productName(product, lang);
  const cat = categoryLabel || product.category;
  if (cat) s += ` — ${cat}`;
  const color = product.colors && product.colors[0];
  if (color) s += ` ${CONJ[lang] || "in"} ${color}`;
  if (index > 0) s += ` (${PHOTO[lang] || "photo"} ${index + 1})`;
  return s;
}

// Stored override (if any) else the auto-generated ALT.
export function getAlt(product, index = 0, lang = "en", categoryLabel = "") {
  const stored = product?.image_alts?.[index]?.[lang];
  return (stored && stored.trim()) || autoAlt(product, index, lang, categoryLabel);
}
